import { GavelRounded } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControlLabel,
  Paper,
  Typography,
} from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import TermsDetail from '../organisms/TermsDetail';
import Log from '../../lib/log';
import Spinner from '../atoms/Spinner';
import { useNavigate } from 'react-router-dom';

// ログの初期化
const log = new Log('Terms');

function TermsContent() {
  log.putLog('info', 'Terms started.');

  // Spinner
  const [loading, setLoading] = useState(true);
  // スピーナーの停止
  const handleTermsLoaded = () => {
    setLoading(false);
  };

  const [terms, setTerms] = useState(false);
  const handleChangeTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTerms(e.target.checked);
  };

  // 次へ
  const navigate = useNavigate();
  const handleNext = (e: any) => {
    return navigate('/setup');
  };

  return (
    <Container component='main' maxWidth='lg' sx={{ mt: 4, mg: 4 }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <GavelRounded />
        </Avatar>
        <Typography component='h1' variant='h5'>
          利用規約への同意
        </Typography>
        <Paper
          style={{
            width: '80%',
            maxHeight: '80%',
            overflow: 'auto',
          }}
        >
          <Box sx={{ margin: 3 }}>
            <Typography component='p' color='gray'>
              以下の利用規約をお読みいただき、同意頂ける場合のみ「同意します」のチェックをONにして、「次へ」ボタンを押してください。
            </Typography>
          </Box>

          <Box
            sx={{ margin: 3 }}
            style={{ maxHeight: '500px', overflow: 'auto' }}
          >
            <Spinner loading={loading} />
            <TermsDetail handleTermsLoaded={() => handleTermsLoaded()} />
          </Box>
          <Box sx={{ margin: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  value='terms'
                  color='primary'
                  checked={terms}
                  disabled={loading}
                  onChange={(e) => handleChangeTerms(e)}
                />
              }
              label='同意します'
            />
          </Box>
        </Paper>
        <Button
          type='submit'
          variant='contained'
          sx={{ mt: 3, mb: 2 }}
          disabled={!terms}
          onClick={handleNext}
        >
          次へ
        </Button>
      </Box>
    </Container>
  );
}

export default function Terms() {
  return <TermsContent />;
}
